import React, { useState, useEffect } from "react";
import { P, SubHeader } from "../../../../../UI toolkit/Text/Text";
import { ToggleButton } from "../../../../../UI toolkit/Input/Input";
import { Card } from "../../../../Units/Card.styled";
import {
  CardHolder,
  CardTitle,
  TabNav,
} from "../../../../Units/CardTitle.styled";
import ic_overview from "../../../../../assets/images/ic-overview-db.svg";
import { connect } from "react-redux";
import Statbox from "./Statbox";
import { getSavingsOverviewStats } from "../../../../../store/Actions/SavingsActions";
import { getP2POverviewStats } from "../../../../../store/Actions/P2PActions";

const OverviewStats = ({ overviewAction, token, overview }) => {
  const TABS = [
    { label: "Today", queryParam: "today" },
    { label: "7 days", queryParam: "7d" },
    { label: "30 days", queryParam: "30d" },
    { label: "All time", queryParam: "all" },
  ];

  const [activeTab, handleTab] = useState(3);

  const [state, setstate] = useState({
    key: null,
    value: null,
  });

  // useEffect(() => {
  //   console.log(queryParam);
  //   overviewAction(queryParam);
  // }, [queryParam, overviewAction, token]);

  const [queryParam, setqueryParam] = useState("all");
  useEffect(() => {
    console.log("overviewStats", overview);
    overviewAction(queryParam);
  }, [queryParam, overviewAction, token]);

  return (
    <div>
      {/* <pre>{JSON.stringify(overview, null, 2)}</pre> */}
      <Card>
        <CardHolder>
          <div className="flex">
            <div className="w-6/12">
              <CardTitle img={ic_overview} text={"Overview"} />
            </div>
            <div className="w-6/12">
              <TabNav
                tabs={TABS}
                activeTab={activeTab}
                handleTab={handleTab}
                p={"4px 8px 3px 8px"}
                Keys={["label", "queryParam"]}
                // borderRadius={"0px"}
                boxShadow={"0px"}
                callback={(curr) => {
                  setqueryParam(curr["queryParam"]);
                }}
              />
            </div>
          </div>
        </CardHolder>
        <div
          className="flex py-6 pl-4"
          style={{ borderBottom: "1px solid #EFF0F5" }}
        >
          <Statbox
            name="TOTAL BUY ADS"
            value={overview ? overview.totalQuantityOfBuyAds : null}
            isMoney={true}
          />
          <Statbox
            name="TOTAL SELL ADS"
            value={overview ? overview.totalQuantityOfSellAds : null}
            isMoney={true}
          />
          <Statbox
            name="TOTAL ADS COUNT"
            value={overview ? overview.totalAdsCount : null}
          />
        </div>

        <div
          className="flex py-6 pl-4"
          style={{ borderBottom: "1px solid #EFF0F5" }}
        >
          <Statbox
            name="TOTAL BUY ORDER"
            value={overview ? overview.totalBuyOrdersCount : null}
            isMoney={true}
          />
          <Statbox
            name="TOTAL SELL ORDER"
            value={overview ? overview.totalSellOrdersCount : null}
            isMoney={true}
          />
          <Statbox
            name="TOTAL ORDER COUNT"
            value={overview ? overview.totalOrdersCount : null}
          />
        </div>
      </Card>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    token: state.auth.token,
    overview: state.p2p.overviewStats,
    loading: state.p2p.loading,
    error: state.p2p.error,
  };
};

// Link Actions to component
const mapDispatchToProps = (dispatch) => {
  return {
    overviewAction: (query) => dispatch(getP2POverviewStats(query)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(OverviewStats);
